module.exports = __webpack_public_path__ + "static/media/harman.f849b83e.jpeg";